const AccessTokenKey = 'Access-Token';
const RefreshTokenKey = 'Refresh-Token';
const LoggedUserKey = 'LoggedUserInfo';
const ClientId = 'Client-Id';
import Cookies from 'js-cookie';
import { ApiUrl } from './index';
import router from '../router';

export function getAccessToken () {
  let token = localStorage.getItem(AccessTokenKey);
  return token ? token : Cookies.get(AccessTokenKey);
}

export function setAccessToken (token) {
  localStorage.setItem(AccessTokenKey, token);
  return Cookies.set(AccessTokenKey, token);
}

export function getRefreshToken () {
  let token = localStorage.getItem(RefreshTokenKey);
  return token ? token : Cookies.get(RefreshTokenKey);
}

export function setRefreshToken (token) {
  localStorage.setItem(RefreshTokenKey, token);
  return Cookies.set(RefreshTokenKey, token);
}

export function getLoggedUser () {
  let userFromLocalStorage = localStorage.getItem(LoggedUserKey);
  let userFromCookie = Cookies.get(LoggedUserKey);

  return userFromLocalStorage && userFromLocalStorage !== 'undefined'
    ? JSON.parse(userFromLocalStorage)
    : userFromCookie && userFromCookie !== 'undefined'
      ? userFromCookie
      : null;
}

export function setLoggedUser (user) {
  let json = JSON.stringify(user);
  localStorage.setItem(LoggedUserKey, json);
  return Cookies.set(LoggedUserKey, json);
}

export function removeToken () {
  localStorage.removeItem(RefreshTokenKey);
  localStorage.removeItem(AccessTokenKey);
  localStorage.removeItem(LoggedUserKey);
  Cookies.remove(RefreshTokenKey);
  Cookies.remove(LoggedUserKey);
  return Cookies.remove(AccessTokenKey);
}

export function getClientId () {
  let id = localStorage.getItem(ClientId);
  return id ? id : Cookies.get(ClientId);
}

export function setClientId (id) {
  localStorage.setItem(ClientId, id);
  Cookies.set(ClientId, id);
}

export function removeClientId () {
  localStorage.removeItem(ClientId);
  Cookies.remove(ClientId);
}

export function setURL (link) {
  let index =
    link.indexOf('?appId') ||
    link.indexOf('?accesstoken') ||
    link.indexOf('?refreshtoken') ||
    link.indexOf('?clientId');
  if (index < 0) return link.replace('403', '');
  let str = link.slice(index, link.length);
  return link.replace(str, '').replace('403', '');
}

export function getURLAuthorize () {
  let returnLink = setURL(getCurrentRoute());
  let url = ApiUrl.Login;
  url += '?appId=' + ApiUrl.AppId;
  url += '&returnUrl=' + encodeURIComponent(returnLink);
  return url;
}

export function getURLAuthorizeWithForce () {
  let returnLink = setURL(getCurrentRoute());
  let url = ApiUrl.Login;
  url += '?force=true&appId=' + ApiUrl.AppId;
  url += '&returnUrl=' + encodeURIComponent(returnLink);
  return url;
}

export function checkRoles (roles) {
  let user = getLoggedUser();
  if (!user || !user.groupRoles || !user.groupRoles.length) return;
  let isDeleteGroupRole = false;
  let isCreateGroupRole = false;
  let isUpdateGroupRole = false;
  let isAddRoleToGroup = false;
  roles.forEach(role => {
    if (role === 'GroupRole') {
      isDeleteGroupRole = user.groupRoles[0].roles.find(item => item.name === 'DeleteGroupRole');
      isCreateGroupRole = user.groupRoles[0].roles.find(item => item.name === 'CreateGroupRole');
      isUpdateGroupRole = user.groupRoles[0].roles.find(item => item.name === 'UpdateGroupRole');
      isAddRoleToGroup = user.groupRoles[0].roles.find(item => item.name === 'AddRoleToGroup');
    }
  });
  return isDeleteGroupRole && isCreateGroupRole && isUpdateGroupRole && isAddRoleToGroup;
}

export function checkGroupRoles (groupRoles) {
  const user = getLoggedUser();
  if (!user || !user.groupRoles || !user.groupRoles.length) return;

  const userGroupRole = user.groupRoles[0].groupName.toLowerCase();
  return groupRoles.some(item => item.toLowerCase() === userGroupRole);
}

export function getCurrentRoute () {
  let currentRoute = router.currentRoute;
  if (currentRoute.name === 'AccessDenied' || currentRoute.name === 'NotFound' || currentRoute.name === 'ServerError') return window.location.origin + '/#/';
  return window.location.href;
}



// WEBPACK FOOTER //
// ./src/utils/auth.js